export var sortFourProductBanners = function() {
    if ($(".nav-four-product").length > 0) {
        var fourProductsArray = [];
        $("[data-fourproductcount]").each(function() {
            fourProductsArray.push($(this).data("fourproductcount"));
        });
        fourProductsArray.sort(function(a, b) {
            return a - b;
        });
        $(fourProductsArray).each(function() {
            $(".related-searches").after($("[data-fourproductcount='" + this + "']"));
        });
    }
    $("#nav-four-product img.lazy-img").lazyload({
        effect: "fadeIn",
        threshold: 200
    });
    $(window).scroll();
};
